var UnauthorizedComponent = /** @class */ (function () {
    function UnauthorizedComponent() {
    }
    return UnauthorizedComponent;
}());
export { UnauthorizedComponent };
